import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemeModule } from '../../../../@theme/theme.module';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [TranslatePipe, RouterModule],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPageComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() img!: string;
}
